// Pidieron una cosa y se hizo otra (28-oct-2026): "Mantenimiento / limpieza" y terminó siendo un retiro.
// Cada texto se lleva a tipos de trabajo; si no comparten ninguno, fue otra cosa y se marca.
const TIPOS = [
    ['INSTALACION', /instal/i],
    ['RETIRO', /retir/i],
    ['LIMPIEZA', /limpie|saniti|filtro|mantenim|service|preventiv/i],
    ['REPARACION', /p[eé]rdida|pierde|gotea|canilla|termostato|no enf|no calien|no enciend|no anda|repar|compresor|bomba/i],
];

export const tiposDe = (texto) => TIPOS.filter(([, re]) => re.test(String(texto || ''))).map(([id]) => id);

/** true si lo pedido y lo hecho son trabajos distintos (los dos se pueden leer). */
export function fueOtraCosa(pedido, hecho) {
    const a = tiposDe(pedido), b = tiposDe(hecho);
    return a.length > 0 && b.length > 0 && !a.some(x => b.includes(x));
}

/** "Retiro de equipo porque no lo utilizan…" → "Retiro de equipo" (lo primero, corto). */
export const corto = (texto, max = 40) => {
    const t = String(texto || '').split(/\s(?:porque|ya que|por que|—|-)\s|[.;(]/i)[0].trim();
    return t.length > max ? `${t.slice(0, max - 1)}…` : t;
};
